import React, { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
  deleteItem,
  fetchData,
  submitForm,
  toggleStatus,
} from "../utils/apiUtils";
import DeleteModel from "../Components/DeleteModel";
import {
  ActionButton,
  PlusButton,
  SwitchToggle,
  ToggleSwitch,
} from "../helper/ImageFormat";
import CustomPagination from "../helper/Pagination";
import Breadcrumb from "../helper/Breadcrumb";
import Spinner from "../Components/spinner";
import dateformate from "../helper/DateFormate";

const SocialMedia = () => {
  const [loading, setLoading] = useState(false);
  const [socialMedia, setSocialMedia] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const [data, setData] = useState({
    icon: "",
    url: "",
    name: "",
    isActive: true,
  });

  const [errors, setErrors] = useState({
    icon: "",
    name: "",
    url: "",
  });

  
  useEffect(() => {
    fetchSocialMedia();
  }, []);

  
  useEffect(() => {
    fetchSocialMedia();
  }, [perPage]);

  const totalPages = Math.ceil(totalCount / perPage);

 
  const fetchSocialMedia = async (page = 1) => {
    const requestData = {
      perPage: perPage,
      pageNo: page,
    };
    await fetchData(
      "socialmedia-pagination",
      requestData,
      setSocialMedia,
      setTotalCount,
      setCurrentPage,
      setLoading
    );
  };

  
  const handleChange = (e) => {
    const { name, files, checked, value } = e.target;
    if (name === "flag") {
      setData({ ...data, [name]: files.length > 0 ? files[0] : "" });
    } else if (name === "isActive") {
      setData({ ...data, [name]: checked });
    } else {
      setData({ ...data, [name]: value });
    }
    setErrors({ ...errors, [name]: "" });
  };

  
 const handleSubmit = async (e) => {
  e.preventDefault();
  setBtnLoading(true);

  const result = await submitForm({
    data,
    url: "/socialmedia",
    editingId,
    validateFields: [
      { name: "icon", message: "Icon is required" },
      { name: "url", message: "Url is required" },
      { name: "name", message: "Name is required" },
    ],
    validationErrorsSetter: setErrors,
    onSuccess: () => fetchSocialMedia(),
    closeModal: () => setModalOpen(false),
  });

  if (result) {
    setModalOpen(false);
    setEditingId(null);
    setData({
      icon: "",
      url: "",
      name: "",
      isActive: true,
    });
    setErrors({
      icon: "",
      name: "",
      url: "",
    });
  }

  setBtnLoading(false);
};

 
  const handleEditClick = (data) => {
    setEditingId(data.id);
    const { createdAt, id, updatedAt, ...otherData } = data;
    setData(otherData);
    setErrors({ icon: "", name: "", url: "" });
    setModalOpen(true);
  };

  
  const handleDelete = async (id) => {
    setDeleteItemId(id.id);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem(
        "socialmedia",
        deleteItemId,
        fetchSocialMedia
      );
      setDeleteItemId(null);
      setDeleteModalOpen(false);
      return res;
    } catch (err) {
      throw err;
    } finally {
      setIsDeleting(false);
    }
  };

 
  const handleStatusToggle = async (social) => {
    const data = await toggleStatus("socialmedia-status", social?.id);
    if (data) {
      setSocialMedia((prevSocialData) =>
        prevSocialData.map((item) =>
          item.id === social.id ? { ...item, isActive: data?.isActive } : item
        )
      );
    }
  };

  
  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchSocialMedia(page);
    }
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    if (!modalOpen) {
      setErrors({ icon: "", name: "", url: "" });
    }
    if (modalOpen) {
      setEditingId(null);
    }
  };

  const handleAddMedia = () => {
    setData({
      icon: "",
      name: "",
      url: "",
      isActive: true,
    });
    setErrors({ icon: "", name: "", url: "" });
    setEditingId(null);
    setModalOpen(true);
  };

  const Tableheader = ["Name", "Icon", "Updated At", "Active", "Action"];
  const breadcrumbdata = [
    { label: "Home", path: "/" },
    { label: "Social Media", path: "*" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5">
          <h3 className="custom-page-title">Social Media</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>

        <div className="d-flex justify-content-end bg-white p-2 mt-n2">
          <PlusButton handleAdd={handleAddMedia} module={"social-media"} />
        </div>

        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className="custom-table table table-striped"
                    id="socialmediatable"
                  >
                    <thead>
                      <tr>
                        {Tableheader.map((item, index) => (
                          <th
                            className="font-weight-bold"
                            key={index}
                          >
                            {item}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <Spinner />
                          </td>
                        </tr>
                      ) : socialMedia.length > 0 ? (
                        socialMedia.map((item, index) => (
                          <tr key={index}>
                            <td>{item.name}</td>
                            <td >{item.icon}</td>
                            <td>{dateformate(item.updatedAt)}</td>
                            <td >
                              <ToggleSwitch
                                data={item}
                                name="isActive"
                                checked={item.isActive}
                                handleStatusToggle={handleStatusToggle}
                                module={"social-media"}
                              />
                            </td>
                            <td>
                              <ActionButton
                                data={item}
                                handleEditClick={handleEditClick}
                                handleDelete={handleDelete}
                                module={"social-media"}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            <h5>No data found.</h5>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {socialMedia.length > 0 && (
                  <CustomPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageClick}
                    perPage={perPage}
                    totalCount={totalCount}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {modalOpen && (
        <Modal
          isOpen={modalOpen}
          toggle={toggleModal}
          centered
          className="white-modal"
        >
          <ModalHeader toggle={toggleModal} className="close-currency">
            {editingId ? "Update" : "Add"} Social Media
          </ModalHeader>
          <form onSubmit={handleSubmit}>
            <ModalBody className="currency">
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control form-control-sm border border-dark"
                  id="icon"
                  name="icon"
                  placeholder="Enter icon"
                  value={data.icon}
                  onChange={handleChange}
                />
                {errors.icon && (
                  <small className="text-danger">{errors.icon}</small>
                )}
              </div>

              <div className="mb-3">
                <input
                  type="text"
                  className="form-control form-control-sm border border-dark"
                  name="name"
                  id="name"
                  placeholder="Enter name"
                  value={data.name}
                  onChange={handleChange}
                />
                {errors.name && (
                  <small className="text-danger">{errors.name}</small>
                )}
              </div>

              <div className="mb-3">
                <input
                  type="text"
                  className="form-control form-control-sm border border-dark"
                  name="url"
                  id="url"
                  placeholder="Enter url"
                  value={data.url}
                  onChange={handleChange}
                />
                {errors.url && (
                  <small className="text-danger">{errors.url}</small>
                )}
              </div>

              <div className="mb-3 p-0">
                <SwitchToggle
                  checked={data.isActive}
                  onChange={(val) =>
                    setData((prev) => ({ ...prev, isActive: val }))
                  }
                  activeLabel="Active"
                  inactiveLabel="Inactive"
                />
              </div>
            </ModalBody>

            <ModalFooter>
              <Button color="primary" type="submit" disabled={btnLoading}>
                {btnLoading ? (
                  <>
                    <i className="fas fa-spinner fa-spin me-2" />
                    {editingId ? "Updating..." : "Adding..."}
                  </>
                ) : editingId ? (
                  "Update"
                ) : (
                  "Add"
                )}
              </Button>
              <Button
                color="danger"
                onClick={toggleModal}
                disabled={btnLoading}
              >
                Cancel
              </Button>
            </ModalFooter>
          </form>
        </Modal>
      )}

      {deleteModalOpen && (
        <DeleteModel
          deleteModalOpen={deleteModalOpen}
          setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
          onConfirm={confirmDelete}
          itemName="social media"
          isDeleting={isDeleting}
        />
      )}
    </>
  );
};

export default SocialMedia;
